import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconCash = ({ t, fill, className, height, width }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox='0 0 39 39'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>{t('Cash')}</title>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(-2)'>
        <path fill={fill} d='M3.693 30.702h35.553V8.693H3.693z' />
        <path fill={fill} d='M40.093 32.395H2.847A.847.847 0 0 1 2 31.55V7.847C2 7.379 2.38 7 2.847 7h37.246c.467 0 .847.38.847.847v23.702c0 .467-.38.846-.847.846z' />
        <path fill='#fff' d='M20.623 25.558c-1.852-.29-3.251-1.521-3.382-3.087a.846.846 0 0 1 .772-.914.844.844 0 0 1 .914.772c.058.688.762 1.275 1.696 1.502v-3.448c-2.287-.56-3.386-1.636-3.386-3.225 0-1.635 1.457-3.003 3.386-3.318v-.914a.847.847 0 0 1 1.693 0v.911c1.853.29 3.25 1.52 3.383 3.088a.846.846 0 0 1-.772.914c-.45.057-.875-.307-.914-.772-.058-.687-.762-1.275-1.697-1.502v3.448c2.287.559 3.388 1.634 3.388 3.226-.001 1.634-1.458 3.001-3.388 3.316v.915a.847.847 0 0 1-1.693 0v-.912zm1.693-1.73c.975-.238 1.692-.87 1.692-1.59 0-.68-.543-1.16-1.692-1.486v3.077zm-1.693-8.262c-.974.24-1.691.872-1.691 1.592 0 .679.542 1.159 1.691 1.485v-3.077zm16.084-3.487h-3.386a.847.847 0 0 1 0-1.693h3.386a.847.847 0 0 1 0 1.693zM9.619 29.01H6.233a.847.847 0 0 1 0-1.693h3.386a.847.847 0 0 1 0 1.693z' />
      </g>
    </g>
  </svg>
)

export default Icon(IconCash)
